import {
  Customizer,
  ITextFieldProps as IFabricTextFieldProps,
  TextField as FabricTextField
} from 'office-ui-fabric-react';
import * as React from 'react';
import { PropsType } from '../../../utils/safDiagnosticSchema';


interface ITextFieldCProps extends IFabricTextFieldProps {}
export class TextField extends React.PureComponent<ITextFieldCProps> {
  public render(): React.ReactNode {
    const { onChange } = this.props;
    return (
      <Customizer
        scopedSettings={{
          TextField: { styles: { fieldGroup: { selectors: { '::after': { borderWidth: 1 } } } } }
        }}
      >
        <FabricTextField
          {...this.props}
          onChange={onChange}
        />
      </Customizer>
    );
  }
}

// workaround bug in fabric typing
export type ITextFieldProps = PropsType<typeof TextField>;
